import * as React from 'react'
import { Navigate, useLocation, useOutletContext } from 'react-router-dom'

import { UpsertAllowanceDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import UpsertAllowance from 'modules/timeoff/components/TimeoffAllowances/UpsertAllowance'
import type { RouteContextParams } from 'modules/timeoff/lib/routeContextParams'

const NewAllowancePage = () => {
  const { navigation } = useNavigation()
  const location = useLocation()
  const { policy } = useOutletContext<RouteContextParams>()
  const policyId = policy?.attributes.id

  const { company } = useCurrentSession()
  const { loading: loadingQuery, data: queryData } = useQuery(UpsertAllowanceDocument, {
    variables: {
      companyId: company.id,
    },
  })

  // If we access this page directly we don't have the previous page state (which is required), so
  // we go back to make users introduce the allowanceName.
  // Also, we can just check the initial state, since the "exiting" state can change and then
  // a false redirect can happen.
  const state = React.useRef<{ allowanceName?: string } | null>(location.state).current

  if (!state || !state.allowanceName) {
    return (
      <Navigate
        to={navigation.settings.timeoffPolicies.id.details.addAllowance.fullPath({ id: policyId })}
      />
    )
  }

  return (
    <UpsertAllowance
      policyId={policyId}
      allowanceName={state.allowanceName}
      queryData={queryData}
      loadingQuery={loadingQuery}
    />
  )
}

export default NewAllowancePage
